// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item-odds+.item-odds[data-v-a4ffb5e4]{border-top:1px solid #e0e0e0}.padding-fix[data-v-a4ffb5e4]{display:inline-block;padding-right:40px !important}.v-sheet[data-v-a4ffb5e4]{background:#121212}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
